import { FilterValuesObject } from '@finn/ua-vehicle';
import isEqual from 'lodash/isEqual';

export const haveFilterValuesChanged = (
  currentValues: FilterValuesObject,
  previousValues: FilterValuesObject
): boolean => {
  return !isEqual(currentValues, previousValues);
};
